import SupportModal from './SupportModal.view';

export default SupportModal;
